import { checkIfSelected, selectContentControl } from "./ContentControl";
import { openPanel } from "../index";
import { CopyCutPasteInstance } from "./CopyCutPaste";
import { COPY_CUT_PASTE_PANEL_MESSAGE, EDIT_OBJECT, OBJECTS_LIST } from "../utils/constants/navigation";
import { CoObjectItem } from "../components/interfaces/CoObject";
import { store } from "../redux/store/store";
import { setPanelMessage } from "../redux/feature/panelMessage/panelMessage-slice";
import { isOnWordWeb } from "../api/config/ExternalConfig";

export const extractSelectedContentControl = async (): Promise<number> => {
  try {
    const response = await checkIfSelected();
    if (!response) return null;
    if (!Array.isArray(response)) {
      return response.id;
    }
    return response?.[0]?.id;
  } catch {
    return null;
  }
};

export async function actionCutContentControl(event) {
  try {
    if (isOnWordWeb()) {
      store.dispatch(setPanelMessage("NOT_COMPATIBLE_WITH_WEB"));
      await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
      return;
    }
    await CopyCutPasteInstance.cut();
    await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
  } finally {
    event.completed();
  }
}

export async function actionCopyContentControl(event) {
  try {
    if (isOnWordWeb()) {
      store.dispatch(setPanelMessage("NOT_COMPATIBLE_WITH_WEB"));
      await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
      return;
    }
    await CopyCutPasteInstance.copy();
    await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
  } finally {
    event.completed();
  }
}

export async function actionPasteContentControl(event) {
  try {
    if (isOnWordWeb()) {
      store.dispatch(setPanelMessage("NOT_COMPATIBLE_WITH_WEB"));
      await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
      return;
    }
    const [pastedSuccessfully, pastedElements] = await CopyCutPasteInstance.paste();

    // error event
    if (!pastedSuccessfully) {
      return await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
    }
    //cut event
    if (!pastedElements) {
      store.dispatch(setPanelMessage("COPY_CUT_UNSUCCESSFULL"));
      return await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
    }
    //copy event
    if (pastedElements?.length === 1) {
      const isSelected = await selectContentControl({
        contentControlId: pastedElements[0]?.contentControlId,
      } as CoObjectItem);
      if (isSelected) await openPanel({ ...event, source: { id: EDIT_OBJECT } });
      return;
    }
    if (pastedElements?.length > 1) {
      await openPanel({ ...event, source: { id: OBJECTS_LIST } });
    }
  } catch (e) {
    console.error(e);
    store.dispatch(setPanelMessage("COPY_CUT_UNSUCCESSFULL"));
    return await openPanel({ ...event, source: { id: COPY_CUT_PASTE_PANEL_MESSAGE } });
  } finally {
    event.completed();
  }
}
